import React from 'react'

export default function Row ({ children }) {
  return <div style={{ height: 15 }}>{children}</div>
}



// WEBPACK FOOTER //
// ./src/row.js